import { createContext } from 'react';

/**
 * A component that lays out its child elements in slots (e.g. the accordion)
 * provides a callback here to learn whether the element in a slot is hidden by
 * a dependency rule. Only the element directly in the slot reports; the loader
 * shields nested elements so a hidden grandchild does not hide the slot.
 */
export type ReportSlotVisibility = (visible: boolean) => void;

export const SlotVisibilityContext = createContext<
  ReportSlotVisibility | undefined
>(undefined);
